import React from "react";
import { useOnboardWizard } from "./domains/useOnboardWizard";
import { OnboardHeader, LaneTabs, PreflightBar } from "./domains/OnboardBits";
import { BuyLane } from "./domains/BuyLane";
import { OwnedLane, ImportLane } from "./domains/CollectLanes";
import { ReviewPhase } from "./domains/ReviewPhase";
import { ProgressPhase } from "./domains/ProgressPhase";

function CollectPhase({ w }) {
  if (w.buyMode) return <BuyLane w={w} />;
  if (w.lane === "owned") return <OwnedLane w={w} />;
  if (w.importLane) return <ImportLane w={w} />;
  return null;
}

/** /admin/domains — Buy / Add owned / Import lanes → Review → live onboarding progress. */
export default function DomainsOnboard() {
  const w = useOnboardWizard();
  return (
    <div className="p-6 max-w-5xl mx-auto" data-testid="domains-onboard-page">
      <OnboardHeader phase={w.phase} />
      <LaneTabs lane={w.lane} onSwitch={w.switchLane} />
      <PreflightBar preflight={w.preflight} cfReg={w.cfReg} balance={w.balance} />
      {w.err && <div data-testid="domains-error" className="mt-4 border border-rose-500/30 bg-rose-500/5 text-rose-300 px-3 py-2 rounded-sm text-xs mono">{w.err}</div>}
      {w.phase === "collect" && <CollectPhase w={w} />}
      {w.phase === "review" && <ReviewPhase w={w} />}
      {w.phase === "progress" && <ProgressPhase w={w} />}
    </div>
  );
}
